import { gql } from "@apollo/client";

export const CREATE_MODULE = gql`
mutation CreateAppModule($createModulesInput: CreateModulesInput!) {
  createAppModule(createModulesInput: $createModulesInput) {
  moduleName
  permissions  
  }
}
`

export const GET_ALL_MODULES = gql`
mutation GetAllModules {
  getAllModules {
    _id
    moduleName
    permissions
  }
}
`